import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.grid}>
          <div className={styles.brand}>
            <Link to="/" className={styles.logo}>
              <img src="/favicon.svg" className={styles.logoIcon} width="28" height="28" alt="SimplifyQR" />
              simplifyqr
            </Link>
            <p>Free QR code generator and scanner. No signup. No watermark. Built for India and the world.</p>
          </div>
          <div className={styles.col}>
            <h4>Tools</h4>
            <Link to="/">QR Generator</Link>
            <Link to="/#scanner">QR Scanner</Link>
            <Link to="/how-it-works">How it Works</Link>
          </div>
          <div className={styles.col}>
            <h4>Company</h4>
            <Link to="/about">About Us</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <div className={styles.col}>
            <h4>Legal</h4>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/cookie-policy">Cookie Policy</Link>
          </div>
        </div>
        <div className={styles.bottom}>
          <p>© {new Date().getFullYear()} simplifyqr. Made with ♥ in India 🇮🇳</p>
          <p>All QR generation is processed locally in your browser. We never store your data.</p>
        </div>
      </div>
    </footer>
  );
}
